<template>
  <v-select
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    :rules="rules"
    :value="value"
    @input="onInput"
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import constants from "../../../helpers/constants";

export default {
  name: "OperationPicker",

  props: ["title", "isRequired", "value"],

  data() {
    return {
      fields: [constants.OP_AND, constants.OP_OR],
    };
  },

  computed: {
    rules() {
      return this.isRequired
        ? ui.requiredRules(this.$store.getters.required)
        : [];
    },
  },

  methods: {
    onInput(e) {
      this.$emit("input", e);
    },
  },
};
</script>